export const imageUrlToBase64 = async (fileSource) => {
    return new Promise((resolve, reject) => {
        fetch(fileSource)
            .then((response) => {
                response.blob().then((blob) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onload = () => {
                        const base64data = reader.result;
                        resolve(base64data)
                    }
                })

            })
            .catch(() => {
                resolve(undefined)
            })

    })
}

export default imageUrlToBase64;
